<template>
  <div class="wg-row" style="justify-content:center;">
    <div class="vertical-height-div" style="height:20px;"></div>
    <div style="font-size:22px;">{{ $anm22.strLang(lang, 'Version', 'Versione') }}</div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="com-anm22-app-text-xxl">ANM22 Calendar V</div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="com-anm22-app-text-l">{{ version }}</div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      version: process.env.VERSION
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, "Settings", "Impostazioni") + ' | ANM22 Calendar';
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Settings", "Impostazioni")
    );
    this.$Progress.finish();
  }
};
</script>

<style lang="scss" scoped>
</style>
